import React from 'react';
import { IIconProps } from '../interfaces';

const AleaFeature03Icon: React.FC<IIconProps> = ({
  color = '#2B4956',
  size = '30',
  active = false,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 30 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Frame 60" opacity={active ? '1' : '0.5'}>
      <g id="Localisation">
        <g id="active">
          <path
            d="M20.1921 27.9639C24.6702 27.9639 28.3003 26.4998 28.3003 24.6938C28.3003 22.8879 24.6702 21.4238 20.1921 21.4238C15.7141 21.4238 12.084 22.8879 12.084 24.6938C12.084 26.4998 15.7141 27.9639 20.1921 27.9639Z"
            stroke={active ? color : '#C6C6C6'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.683 8.28986C15.683 12.3723 8.2717 23.7525 8.2717 23.7525C8.2717 23.7525 0.860352 12.3723 0.860352 8.28986C0.860352 4.20746 4.17903 0.896484 8.2717 0.896484C12.3644 0.896484 15.683 4.20746 15.683 8.28986Z"
            fill={active ? color : '#DCDCDC'}
          />
          <path
            d="M15.683 8.28986C15.683 12.3723 8.2717 23.7525 8.2717 23.7525C8.2717 23.7525 0.860352 12.3723 0.860352 8.28986C0.860352 4.20746 4.17903 0.896484 8.2717 0.896484C12.3644 0.896484 15.683 4.20746 15.683 8.28986Z"
            stroke={active ? color : '#C6C6C6'}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.5984 9.1273C9.95674 10.3789 8.41758 10.8749 7.15847 10.2378C5.89936 9.60062 5.40101 8.06915 6.04269 6.81985C6.68437 5.56828 8.22353 5.0722 9.48265 5.70937C10.7418 6.34653 11.2401 7.878 10.5984 9.12957"
            fill="white"
          />
          <path
            d="M10.5984 9.1273C9.95674 10.3789 8.41758 10.8749 7.15847 10.2378C5.89936 9.60062 5.40101 8.06915 6.04269 6.81985C6.68437 5.56828 8.22353 5.0722 9.48265 5.70937C10.7418 6.34653 11.2401 7.878 10.5984 9.12957V9.1273Z"
            stroke={active ? color : '#C6C6C6'}
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default AleaFeature03Icon;
